import React from 'react';
import { Modal } from 'react-bootstrap';
import closeIcon from '../../images/popups/upload/closeicon.png';
import '../../scss/popups/delete_item.scss';

function DeleteItem({show, handleClose, deleteApiCall, enable, type}) {
    return (
        <>
            <Modal
                show={show}
                onHide={handleClose} className='delete-item-popup'
                centered>
                <Modal.Body className='delete-item-body'>
                    <div className='close-icon'>
                        <img src={closeIcon} onClick={handleClose}/>
                    </div>
                    <div className='delete-popup-header'>{type == "restore" ? "Confirm Restore" : "Confirm Delete"}</div>
                    <div className='delete-popup-subheader'>{type == "restore" ? "Are you sure you want to restore this item?" : 
                    "Are you sure you want to delete this item?"}</div>
                    <div className='delete-button'>
                        <button disabled={enable ? false : true} className={enable ? 'add-button enable' : 'add-button disable'} onClick={deleteApiCall}>
                            {type == "restore" ? "Restore" : "Delete"}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default DeleteItem;